// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "chartkick/chart.js"
import { Chart } from "chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"

import "trix"
import "@rails/actiontext"

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js")
}

Chart.register(ChartDataLabels)

Chart.defaults.set("plugins.datalabels", {
  display: (context) => {
    const canvas = context.chart?.canvas
    return Boolean(canvas?.closest("[data-devices-pie-chart-labels='true']"))
  },
  color: "#FFFFFF",
  font: {
    weight: "600",
    size: 11
  },
  formatter: (_value, context) => context.chart?.data?.labels?.[context.dataIndex] || "",
  anchor: "center",
  align: "center",
  clamp: true
})
